import React from 'react';
import { useLocation } from 'react-router';
import { BRAND } from '../mock/mockData.js';

export default function Privacy() {
  const { pathname } = useLocation();
  const isAppMode = pathname === '/privacy-policy';
  const termsLink = isAppMode ? '/terms-and-condition' : '/terms';

  return (
    <div className="legal">
      <h1>Privacy Policy</h1>
      <p className="ldate">Last updated: 1 March 2025</p>
      <p>ABNScripts Technologies Pvt. Ltd. ("TotalPe", "we") is committed to protecting your privacy. This Policy explains what data we collect, how we use it, and your rights in compliance with the Information Technology (Amendment) Act, 2008 and applicable RBI guidelines.</p>
      <h2>1. Information We Collect</h2>
      <p><strong>Business Information:</strong> Business name, GSTIN, FSSAI number, registered address and bank account details for payment settlement.</p>
      <p><strong>Personal Information:</strong> Your name, mobile number, email address and Aadhaar-linked information as required by KYC regulations for payment processing.</p>
      <p><strong>Transaction Data:</strong> All billing and payment transactions including items sold, amounts, timestamps and payment methods.</p>
      <p><strong>Usage Data:</strong> Device identifiers, IP addresses, app version and feature usage logs to improve the product.</p>
      <p><strong>Location Data:</strong> With your permission, approximate location to enable city-wise analytics and regional compliance features.</p>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide, maintain and improve the TotalPe platform</li>
        <li>To process payments and settle funds to your bank account</li>
        <li>To generate GST reports and assist with regulatory compliance</li>
        <li>To send product updates, security alerts and support communications</li>
        <li>To detect and prevent fraud, money laundering and abuse</li>
        <li>To comply with RBI, GSTN and Indian tax authority requirements</li>
        <li>To conduct anonymised analytics for product improvement</li>
      </ul>
      <h2>3. Data Sharing</h2>
      <p>We do not sell your personal data. We share data only with RBI-licensed payment aggregators, Amazon Web Services (AWS India region) for hosting, legal authorities when required by law, and professional advisors under confidentiality obligations.</p>
      <h2>4. Data Storage & Security</h2>
      <p>All data is stored on servers in India (AWS Mumbai region). We implement TLS 1.3 encryption in transit, AES-256 encryption at rest, role-based access control with MFA, regular third-party penetration testing, SOC 2-compliant infrastructure and PCI-DSS compliance for payment card data.</p>
      <h2>5. Data Retention</h2>
      <p>We retain business and transaction data for a minimum of 8 years to comply with GST and income tax regulations. Personal account data is deleted within 90 days of account closure, subject to legal retention requirements.</p>
      <h2>6. Your Rights</h2>
      <ul>
        <li><strong>Access:</strong> Request a copy of all personal data we hold about you</li>
        <li><strong>Correction:</strong> Request correction of inaccurate or incomplete data</li>
        <li><strong>Erasure:</strong> Request deletion of personal data, subject to legal retention obligations</li>
        <li><strong>Portability:</strong> Receive your transaction data in CSV or JSON format</li>
        <li><strong>Withdraw consent:</strong> Opt out of marketing communications via in-app settings</li>
      </ul>
      <p>To exercise these rights, email <a href={`mailto:${BRAND.email}`} style={{ color:'var(--vivid)' }}>{BRAND.email}</a> with subject "Privacy Request".</p>
      <h2>7. Cookies</h2>
      <p>Our website uses essential cookies for authentication and session management, and anonymised analytics cookies. We do not use third-party advertising cookies.</p>
      <h2>8. Children's Privacy</h2>
      <p>TotalPe is a business platform for adults (18+). We do not knowingly collect data from individuals under 18.</p>
      <h2>9. Changes to This Policy</h2>
      <p>Material changes will be communicated via in-app notification or email at least 15 days before taking effect.</p>
      <h2>10. Grievance Officer</h2>
      <div className="lbox">
        <p style={{ margin:0 }}>
          <strong>Grievance Officer:</strong> Punam Bhagat<br/>
          ABNScripts Technologies Pvt. Ltd., Pimpri-Chinchwad, Maharashtra 411018<br/>
          Email: <a href={`mailto:${BRAND.email}`} style={{ color:'var(--vivid)' }}>{BRAND.email}</a>
          &nbsp;|&nbsp;Phone: <a href={`tel:${BRAND.phone}`} style={{ color:'var(--vivid)' }}>{BRAND.phone}</a><br/>
          Response time: within 30 days of receipt
        </p>
      </div>
    </div>
  );
}